<ng-container *ngIf="!loading && tableTabs.length > 0">
  <div class="row d-none d-md-block" style="padding: 0 15px 15px"
       *ngIf="tableTabs.length > 1 && showTabs && !showAllGroups">
    <button *ngIf="showAllGroupsTab && !this.bundesligaSpecial"
            mat-button class="league-selection" (click)="onTabChange(-1)"
            [class.active]="selectedTabIndex === -1">Alle Gruppen</button>
    <ng-container *ngFor="let tab of tableTabs; let i = index">
      <button mat-button class="league-selection" (click)="onTabChange(i)"
              [class.active]="selectedTabIndex === i">{{ tab.name }}</button>
    </ng-container>
  </div>
  <div class="row d-block d-md-none">
    <mat-form-field class="select-field" *ngIf="tableTabs.length > 1 && showTabs && !showAllGroups" appearance="none">
      <mat-select disableOptionCentering panelClass="select-field-dropdown" [value]="selectedTabIndex">
        <mat-select-trigger>
          <img src="{{ leagueLogoUrl }}" class="league-logo" alt="League Logo">
          {{selectedTabIndex === -1 ? 'Alle Gruppen' : tableTabs[selectedTabIndex].name}}
        </mat-select-trigger>
        <mat-option class="mat-opt-group"
                    *ngIf="showAllGroupsTab && !this.bundesligaSpecial"
                    [value]="-1"
                    (click)="onTabChange(-1)">
          <img src="{{ leagueLogoUrl }}" class="league-logo" alt="League Logo">
          Alle Gruppen
        </mat-option>
        <mat-option class="mat-opt-group"
                    *ngFor="let tab of tableTabs; let i = index"
                    [value]="i"
                    (click)="onTabChange(i)">
          <img src="{{ leagueLogoUrl }}" class="league-logo" alt="League Logo">
          {{tab.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="season-select select-field"
                    appearance="none"
                    *ngIf="showTabs && expandable && showSeasonSelect">
      <mat-select disableOptionCentering panelClass="select-field-dropdown" [value]="selectedSeason">
        <mat-option class="mat-opt-group"
                    *ngFor="let season of availableSeasons"
                    (click)="onSeasonSelect(season)"
                    [value]="season">
          {{season.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Tables for tabs -->
  <div class="row">
    <div class="col-md-12" [ngClass]="{'tables-container-grid-layout': showAllGroups}">
      <ng-container *ngFor="let tab of tableTabs; let tabIndex = index">
        <ng-container *ngFor="let tableData of tab.tables; let tableIndex = index">
          <lib-standings-table *ngIf="canShowTable(tabIndex, tableIndex)"
                               class="table"
                               [colorScheme]="colorScheme"
                               [highlightTeamId]="highlightTeamId"
                               [smallTable]="smallTable"
                               [openLinksInNewTab]="openLinksInNewTab"
                               [showLeagueName]="tableTabs?.length <= 1"
                               [expandable]="expandable"
                               [condensed]="condensed"
                               [leagueLogo]="leagueLogoUrl"
                               [leagueName]="league?.name"
                               [leagueLink]="showHeader ? link : null"
                               [showAllColumnNames]="!showHeader"
                               [rowLimit]="rowLimit"
                               [showMoreButton]="showMoreButton(tableData)"
                               [kroneTable]="readableTableHeaders"
                               [tableData]="tableData"></lib-standings-table>
        </ng-container>
        <div *ngIf="!loading && tableTabs.length === 0">
          <p>Tabelle konnte nicht geladen werden</p>
        </div>
      </ng-container>
      <ng-container *ngIf="loading === true">
        <div class="container mb-1 mt-1">
          <mat-spinner strokeWidth="2" color="primary" diameter="54" class="m-auto"></mat-spinner>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
